var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.image)?_c('CaptionImage',{attrs:{"image":_vm.image,"width":980,"height":540,"mobile-width":375,"mobile-height":320,"lazy":""}},[_vm._v("\n  "+_vm._s(_vm.image.attributes.description)+"\n  "),(_vm.image.attributes.copyright)?[_vm._v(" © "+_vm._s(_vm.image.attributes.copyright)+" ")]:_vm._e()],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }